<div [formGroup]="overrideForm">
  <div class="row g-3 align-items-end">
    <div class="col-12 col-md-6 col-xl-4">
      <label class="form-label" for="tenantThemeOverrideVariable">{{ 'i18n.domain.theme-showcase.tenantTheme.override.variable' | translate }}</label>
      <ejs-dropdownlist
        id="tenantThemeOverrideVariable"
        [dataSource]="tenantOverrideVariableOptions"
        formControlName="overrideVariable"
        [allowFiltering]="true">
      </ejs-dropdownlist>
    </div>

    <div class="col-12 col-md-6 col-xl-2">
      <label class="form-label" for="tenantThemeOverrideMode">{{ 'i18n.domain.theme-showcase.tenantTheme.override.mode' | translate }}</label>
      <ejs-dropdownlist
        id="tenantThemeOverrideMode"
        [dataSource]="tenantOverrideModeOptions"
        [fields]="dropdownFields"
        formControlName="overrideMode">
      </ejs-dropdownlist>
    </div>

    <div class="col-12 col-md-8 col-xl-4">
      <label class="form-label" for="tenantThemeOverrideValueHex">{{ 'i18n.domain.theme-showcase.tenantTheme.override.value' | translate }}</label>
      <app-color-picker-field
        class="theme-override-value-field"
        id="tenantThemeOverrideValue"
        [showLabel]="false"
        [showHint]="false"
        [value]="overrideForm.controls.overrideValue.value"
        (valueChange)="onOverrideValueChanged($event)">
      </app-color-picker-field>
    </div>

    <div class="col-12 col-md-4 col-xl-2 d-grid">
      <button type="button" class="btn btn-outline-secondary" (click)="addThemeTokenOverride()">
        {{ overrideAddOrUpdateButtonLabelKey | translate }}
      </button>
    </div>
  </div>
</div>

@if (rows.length) {
  <div class="mt-3 d-flex align-items-center justify-content-between gap-2">
    <span class="fw-semibold">{{ 'i18n.domain.theme-showcase.tenantTheme.override.listTitle' | translate }} ({{ rows.length }})</span>
    <app-collapse-button [isExpanded]="isOverrideListExpanded" (toggleExpand)="toggleOverrideList()"></app-collapse-button>
  </div>

  @if (isOverrideListExpanded) {
    <div class="mt-2">
      <ejs-grid
        width="100%"
        [dataSource]="rows"
        [allowPaging]="false"
        [allowSorting]="true"
        [rowHeight]="42"
        (commandClick)="onThemeTokenOverrideCommandClick($event)">
        <e-columns>
          <e-column field="variable" [headerText]="'i18n.domain.theme-showcase.tenantTheme.override.variable' | translate" [width]="280"></e-column>
          <e-column [headerText]="'i18n.domain.theme-showcase.tenantTheme.override.mode' | translate" [width]="140">
            <ng-template #template let-data>
              {{ getOverrideModeTranslationKey(data.mode) | translate }}
            </ng-template>
          </e-column>
          <e-column [headerText]="'i18n.domain.theme-showcase.tenantTheme.override.value' | translate">
            <ng-template #template let-data>
              <span class="theme-token-value-cell">
                <span class="theme-token-value-swatch" [style.background-color]="data.value"></span>
                <code class="theme-token-value-code">{{ data.value }}</code>
              </span>
            </ng-template>
          </e-column>
          <e-column [headerText]="'i18n.domain.theme-showcase.tenantTheme.override.actions' | translate" [width]="130" [allowSorting]="false" [textAlign]="'Right'" [commands]="themeTokenOverrideGridCommands"></e-column>
        </e-columns>
      </ejs-grid>
    </div>
  }
} @else {
  <small class="text-body-secondary d-block mt-3">{{ 'i18n.domain.theme-showcase.tenantTheme.override.empty' | translate }}</small>
}

